export default function getPaymentRedirectUrl(orderId: string, token: string) {
  const redirectUrl = `${
    process.env.REACT_APP_GET_REDIRECTION_URL
  }?orderId=${orderId}&token=${encodeURIComponent(token)}`;

  window.location.href = redirectUrl;
}
